module.exports = __webpack_public_path__ + "img/avatar.bfe233d1.jpg";